import { render, staticRenderFns } from "./ClinicTreatmentCustomer.vue?vue&type=template&id=7d531100"
import script from "./ClinicTreatmentCustomer.vue?vue&type=script&lang=js"
export * from "./ClinicTreatmentCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports